import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';


//Para los select
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

export default class MemberInfo extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Member Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="first_name"
              name="first_name"
              label="First Name"
              fullWidth
              autoComplete="fname"
              value={this.props.member.first_name}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.first_name}
              helperText={this.props.errores.first_name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="last_name"
              name="last_name"
              label="Last Name"
              fullWidth
              autoComplete="lname"
              value={this.props.member.last_name}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.last_name}
              helperText={this.props.errores.last_name}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="position"
              name="position"
              label="Position"
              fullWidth
              autoComplete="position"
              value={this.props.member.position}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.position}
              helperText={this.props.errores.position}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div style={{marginTop:'5%'}}>
              <InputLabel htmlFor="member_status" style={{marginRight:'10px'}}>Member Status</InputLabel>
              <Select
                required
                id="member_status"
                name="member_status"
                value={this.props.member.member_status}
                onChange={this.props.handleChange}
                disabled={this.props.reviewActive}
                error={this.props.errores.member_status}
                helperText={this.props.errores.member_status}
              >
                <MenuItem native="true" key={1} value={1} selected>
                  Active
                </MenuItem>
                <MenuItem native="true" key={2} value={2}>
                  Inactive
                </MenuItem>
              </Select>
            </div>
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/member/MemberInfo.js